import "./ContactUs.css"
import ContactForm from '../components/contactForm' 
import { useParams } from "react-router";

function ContactUs() {

  const { prefillSubjectData } = useParams();

  return (
    <div id="contact" className="contactPageContainer">
        <h1 style={{  fontSize: "48px", textSizeAdjust: "8xl", color: "black", font: "thin"}}>
          Contact Us  
        </h1>
        <p style={{fontSize: "16pt"}}>
          Want an estimate? Have a question? Looking for work? Need to contact us for any reason? Fill out this web form and we will get back to you as soon as we can. 
          Please be as specific as possible, but do not include any sensitive information such as home addresses. We will collect that information
          when we contact you back to schedule an estimate.
        </p>
        <div className="contactContentContainer">
          <ContactForm prefillData={{subject: prefillSubjectData}}/>
        </div>
    </div>
  )
}

export default ContactUs